/** @jsx CanvaSX */
import { CanvaSX } from '@lib/canvasx/canvasx';
import { Text } from '@lib/canvasx/components/Text';
import { Image } from '@lib/canvasx/components/Image';
import { Rect } from '@lib/canvasx/components/Rect';
import { type AvatarStructure } from '../shared-types';
import { canvasCssValue } from '@lib/canvasx/util';

export type UserAvatarProps = {
  size: number;
} & AvatarStructure;

export const UserAvatar: CanvaSXFC<UserAvatarProps> = function ({
  initials,
  name,
  size,
  src,
}) {
  initials ||= String(name)
    .split(/\s+/)
    .slice(0, 2)
    .map(str => str[0].toUpperCase())
    .join('');

  return src ? (
    <Image src={src} width={size} height={size} rounded tooltip={name} />
  ) : (
    <Rect
      borderRadius={size}
      fill={canvasCssValue('--aha-gray-500', 'rgb(205, 205, 205)')}
      tooltip={name}
      width={size}
      height={size}
    >
      <Text
        size={size * 0.5}
        color={canvasCssValue('--theme-primary-text', '#fff')}
        x={size * 0.5}
        y={size * 0.5}
        textAlign='center'
        textBaseline='middle'
      >
        {initials}
      </Text>
    </Rect>
  );
};
